import { render } from "./game-interface.vue?vue&type=template&id=27d96683&scoped=true"
import script from "./game-interface.vue?vue&type=script&lang=js"
export * from "./game-interface.vue?vue&type=script&lang=js"

import "./game-interface.vue?vue&type=style&index=0&id=27d96683&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d96683"]])

export default __exports__